import { domains } from 'lib/config'
import { createClient } from 'lib/Api'
import { AxiosPromise } from 'axios'
import { BulkSitePreferenceResponse } from 'types'

/**
 * Second Step API Client V5:
 *
 * This file contains the API client for the Second Step API V5.
 */

const baseApiAddress = `${domains.SS_API_V5}`

// We need to set auth on this specific client instance
export const _ssapiV5 = (customApiAddress?: string) => {
  const _api = createClient(customApiAddress || baseApiAddress)

  return {
    // =========================================================================
    // SITES
    // =========================================================================
    bulkUpdateSitePreferences: (
      bodyFormData: FormData,
    ): AxiosPromise<BulkSitePreferenceResponse> =>
      _api.patch(`/sites/bulkpreferences`, bodyFormData),
  }
}
const ssapiV5 = _ssapiV5()
export default ssapiV5
